import { useEffect, useState } from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { ServiceRotationOption, ServiceRotationTypeOption } from '@mark43/cad-api';
import { ServiceRotationFormType } from './types';
import { isEqual } from 'lodash';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';

export function useResetServiceProviderFormOnChange(
    form: UseFormReturn<ServiceRotationFormType>,
    setManuallySelectedServiceProvider: (provider?: ServiceRotationOption) => void
) {
    const { enhancedServiceRotation: isEnhancedServiceRotationEnabled } = useEnabledFeatures();
    const serviceRotationListName = isEnhancedServiceRotationEnabled
        ? 'serviceRotationArea'
        : 'serviceRotationList';

    const serviceType = useWatch({
        control: form.control,
        name: 'serviceRotationTypeOption',
    });
    const [
        previousServiceType,
        setPreviousServiceType,
    ] = useState<ServiceRotationTypeOption | null>(serviceType);
    const rotationArea = useWatch({
        control: form.control,
        name: serviceRotationListName,
    });

    useEffect(() => {
        setManuallySelectedServiceProvider(undefined);
    }, [form, setManuallySelectedServiceProvider, serviceType, rotationArea]);

    useEffect(() => {
        if (!isEqual(serviceType, previousServiceType)) {
            form.setValue(serviceRotationListName, null);
            form.setValue('serviceRotationTypeCapability', null);
            setPreviousServiceType(serviceType);
        }
    }, [form, serviceType, previousServiceType, serviceRotationListName]);
}
